import throttle from 'lodash/throttle'
import { ready, isElementInViewport } from '../base/utils'

let images

const collectLazyloadImages = (loadImages = true) => {
  images = document.querySelectorAll('img.lazyload:not(.loaded):not(.loading)')
  if (loadImages) lazyloadImages()
}

const lazyloadImages = () => {
  if (images && images.length > 0) {
    images.forEach((image) => {
      if (isElementInViewport(image)) {
        if (!image.classList.contains('loading') && !image.classList.contains('loaded')) {
          image.classList.add('loading')

          if (image.dataset.src) {
            image.src = image.dataset.src
            image.removeAttribute('data-src')
          }
          if (image.dataset.srcset) {
            image.setAttribute('srcset', image.dataset.srcset)
            image.removeAttribute('data-srcset')
          }
          image.addEventListener('load', (e) => {
            e.target.classList.replace('loading', 'loaded')
            collectLazyloadImages(false)
          })
        }
      }
    })
  }
}

ready(() => {
  window.addEventListener('resize', throttle(lazyloadImages, 200))
  window.addEventListener('scroll', throttle(lazyloadImages, 200))

  setTimeout(() => {
    collectLazyloadImages()
  }, 200)
})

// custom event lo trigger lazyloadImages
document.addEventListener('lazyloadImages', collectLazyloadImages)
